import type React from 'react';
import { CircularProgress, type CircularProgressProps } from './CircularProgress';
import {
  CircularProgressContent,
  type CircularProgressContentProps,
} from './CircularProgressContent';

export interface CircularProgressIndicatorProps
  extends Omit<CircularProgressProps, 'className' | 'style'>,
    Omit<CircularProgressContentProps, 'className' | 'style'> {
  /** Container className */
  className?: string;
  /** Container style */
  style?: React.CSSProperties;
  /** Progress container className */
  progressClassName?: string;
  /** Progress container style */
  progressStyle?: React.CSSProperties;
  /** Content container className */
  contentClassName?: string;
  /** Content container style */
  contentStyle?: React.CSSProperties;
}

export const CircularProgressIndicator: React.FC<CircularProgressIndicatorProps> = ({
  // Progress props
  value,
  max,
  size = 120,
  strokeWidth = 8,
  colorScheme,
  thresholds,
  allowOvertime = true,
  maxOvertime = 1.5,
  progressClassName,
  progressStyle,

  // Content props
  format = 'percentage',
  label,
  sublabel,
  contentClassName,
  contentStyle,

  // Container props
  className,
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        position: 'relative',
        display: 'inline-block',
        ...style,
      }}
    >
      <CircularProgress
        value={value}
        max={max}
        size={size}
        strokeWidth={strokeWidth}
        colorScheme={colorScheme}
        thresholds={thresholds}
        allowOvertime={allowOvertime}
        maxOvertime={maxOvertime}
        className={progressClassName}
        style={progressStyle}
      />
      <CircularProgressContent
        value={value}
        max={max}
        format={format}
        label={label}
        sublabel={sublabel}
        colorScheme={colorScheme}
        thresholds={thresholds}
        className={contentClassName}
        style={contentStyle}
      />
    </div>
  );
};

export default CircularProgressIndicator;
